<template>




             <v-parallax dark :src="require(`../../assets/images/bg/${$vuetify.theme.dark ? 'bg-dark' : 'bg-light'}.png`)"  height="1100">
            <v-row align="center" justify="center">
                <v-col class="text-center" cols="6">



                    <base-card>

                   

                        <div slot="card-body">
                        <img src="../../assets/images/error.png">
                         <v-btn color="#00dfbf" class="black--text" @click="goDashboard1()" block>
                                  ERROR 404
                                </v-btn>
                        </div>
                    </base-card>




                </v-col>
            </v-row>
        </v-parallax>

   
</template>

<script>
    import BaseCard from "../../components/Base/BaseCard.vue";


    export default {
        components: {
            BaseCard,


        },
        data() {
            return {
                show1: false,
                show2: true,
                show3: false,
                show4: false,
                password: 'Password',
                rules: {
                    required: value => !!value || 'Required.',
                    min: v => v.length >= 8 || 'Min 8 characters',
                    emailMatch: () => (`The email and password you entered don't match`),
                },
            }
        },
        methods: {
             goDashboard1() {
				return this.$router.push("/dashboard/dashboard1");
			},
        },
    }
</script>